<template>

  <v-app id="parent">
    <v-main>
      <v-container >
        <v-row no-gutters>
          <v-col class="ma-0 pa-0">
            <router-view :key="currentEpochTime"></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

        <!-- Begin - Settings Modal -->
    <v-dialog
      v-model="settingsModalVisible"
      persistent
      width="300"
    >
      <v-card>
        <v-layout justify-center>
          <v-card-title class="text-center">PRMA Personal Settings</v-card-title>
        </v-layout>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col><v-text-field label="Default Airport" placeholder="Make Selection..."></v-text-field></v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-layout justify-center>
          <v-card-actions>
            <v-btn color="white" class="blue--text text--darken-4" @click="settingsModalVisible = false">Close</v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End - Settings Modal -->

  </v-app>

</template>

<script>

//import UserInfoStore from './app/user-info-store'

export default {
  name: "App",
  components: {
  },
  data(){
    return {

      //loggedIn: this.userinfo.loggedIn,
      sidebar: false,
      aboutModal: false,
      settingsModalVisible: false,
      isloggedIn: false,
      aboutModalVisible: false
    }
  },
  computed: {
    currentEpochTime: function () {
      return Date.now()
    }
  },
  methods: {
    reload() {
      this.$router.go();
      this.setAppUpdateNeeded(false);
      //console.log("test");
    },
    goBack() {
      //var newIndex = (this.globalIndex) + 1;
      //this.setGlobalIndex(newIndex);
      this.$router.back();
    },
    goHome() {
      //var newIndex = 0;
      //this.setGlobalIndex(newIndex);
      this.$router.push({name:'Home'});
    },
    logout() {
      //this.$router.go(-1)
      this.$router.replace({name: 'Logout'})
    },
  }
}
</script>
<style>
#parent{
    height: 100%;
    width: 100%;
    overflow: hidden;
}


#child{
    width: 100%;
    height: 100%;
    overflow-y: scroll;
}
#container {
    width:100%;
    text-align:center;
}

#left {
    float:left;
    width:35px;
    max-width:35px;
}

#center {
    display: inline-block;
    margin:0 auto;
    width:auto;
    z-index: 100;
}

#right {
    float:right;
    width:35px;
    max-width:35px;
}

#clear {
  clear:both;
}

.DefaultWidth {
  max-width: 500px;
  margin: auto;
}

</style>

